import { Splide } from "@splidejs/splide";
import { setupCustomTabs } from './tabs.js';

export function initProductSingle() {
    if (!document.querySelector(".product__data")) return;

    const dataElement =
        document.querySelector('.product__data');

    const variantElements =
        dataElement.querySelectorAll(
            '.product__variant'
        );

    const variantsElement =
        document.getElementById(
            'product-variants'
        );

    const titleElement =
        document.getElementById(
            'product-title'
        );

    const descriptionElement =
        document.getElementById(
            'product-description'
        );

    const informationElement = document.querySelector('.product__information');

    const descriptionToggle = document.getElementById('product-description-toggle');
    const descriptionMobile = window.matchMedia('(max-width: 767.98px)');

    const updateDescriptionToggle = () => {
        descriptionElement.style.maxHeight = '';
        descriptionElement.style.overflow = '';
        descriptionToggle.hidden = true;
        descriptionToggle.setAttribute('aria-expanded', 'false');
        descriptionToggle.textContent = 'Lihat lebih';

        if (!descriptionMobile.matches) return;

        const style = getComputedStyle(descriptionElement);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
        const collapsedHeight = lineHeight * 3;
        const hasMore = descriptionElement.scrollHeight > collapsedHeight + 1;

        descriptionToggle.hidden = !hasMore;
        descriptionElement.style.setProperty('--description-collapsed-height', `${collapsedHeight}px`);
        descriptionElement.style.overflow = hasMore ? 'hidden' : '';
        descriptionElement.style.maxHeight = hasMore ? `${collapsedHeight}px` : '';
    };

    descriptionToggle.addEventListener('click', () => {
        if (!descriptionMobile.matches) return;
        const expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
        descriptionToggle.setAttribute('aria-expanded', String(!expanded));
        descriptionToggle.textContent = expanded ? 'Lihat lebih' : 'Lihat sedikit';
        descriptionElement.style.maxHeight = expanded
            ? descriptionElement.style.getPropertyValue('--description-collapsed-height')
            : '';
        descriptionElement.style.overflow = expanded ? 'hidden' : '';
    });

    descriptionMobile.addEventListener('change', updateDescriptionToggle);

    const packageOptionsElement =
        document.getElementById(
            'product-package'
        );

    const packageTitleElement =
        packageOptionsElement.querySelector(
            '.product__options-title'
        );

    const packageListElement =
        packageOptionsElement.querySelectorAll(
            '.product__options-list'
        )[0];

    const infoElement = document.querySelector('.product__info');
    // const infoTitleElement = infoElement.querySelector('.product__info-title');
    // const infoListElement = infoElement.querySelector('.product__info-list');


    let activeVariant = 0;

    let activePackage = 'general';

    const mainSlider = new Splide(
        '#product-main',
        {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: false,
            breakpoints: {
                768: {
                    pagination: true,
                }
            }
        }
    );


    const thumbsSlider = new Splide(
        '#product-thumbs',
        {
            direction: 'ttb',
            height: 'auto',
            perPage: 'auto',
            gap: 8,
            pagination: false,

            arrows: false,

            isNavigation: true,

            wheel: false,

            breakpoints: {

                768: {

                    direction: 'ltr',

                    height: 'auto',

                    perPage: 4

                }

            }
        }
    );


    /*
     * ==========================================================
     * SYNC
     * ==========================================================
     */

    mainSlider.sync(
        thumbsSlider
    );


    /*
     * ==========================================================
     * MOUNT
     * ==========================================================
     *
     * Mount SEBELUM renderGallery().
     *
     * Ini menghindari error:
     *
     * "can't access property Controller"
     *
     */

    mainSlider.mount();

    thumbsSlider.mount();


    /*
     * ==========================================================
     * GET ACTIVE VARIANT
     * ==========================================================
     */

    function getActiveVariant() {

        return variantElements[
            activeVariant
        ];

    }


    /*
     * ==========================================================
     * UPDATE CONTENT
     * ==========================================================
     */

    function updateVariantContent() {

        const variant =
            getActiveVariant();


        const title =
            variant.querySelector(
                '.product__variant-title'
            );


        const description =
            variant.querySelector(
                '.product__variant-description'
            );


        titleElement.textContent =
            title.textContent.trim();


        descriptionElement.replaceChildren(...Array.from(description.childNodes, node => node.cloneNode(true)));

        updateDescriptionToggle();

        const information = variant.querySelector('.product__variant-information');
        informationElement.replaceChildren(...(information
            ? Array.from(information.childNodes, node => node.cloneNode(true))
            : []));
        informationElement.querySelectorAll('[data-tabs]').forEach(container => setupCustomTabs(container));

        // const info = variant.querySelector('.product__variant-info');
        // infoElement.hidden = !info;
        // infoTitleElement.textContent = info ? info.dataset.title || '' : '';
        // infoListElement.replaceChildren(...(info ? Array.from(info.children, item => item.cloneNode(true)) : []));

    }


    /*
     * ==========================================================
     * GET VARIANT GALLERY
     * ==========================================================
     */

    function getVariantGallery() {

        const variant =
            getActiveVariant();


        const gallery = [];


        /*
         * Ambil SEMUA gallery (pcs + box)
         * dari variant yang dipilih.
         */

        variant
            .querySelectorAll(
                '.product__gallery'
            )
            .forEach(
                element => {

                    gallery.push({

                        image:
                            element.textContent.trim(),

                        package:
                            element.closest(
                                '.product__package'
                            ).dataset.package

                    });

                }
            );


        return gallery;

    }


    /*
     * ==========================================================
     * RENDER VARIANT OPTIONS
     * ==========================================================
     */

    function renderVariants() {

        variantsElement.innerHTML = '';


        variantElements.forEach(
            (variant, index) => {

                const name =
                    variant.querySelector(
                        '.product__variant-name'
                    );


                const label =
                    document.createElement(
                        'label'
                    );


                const input = document.createElement('input');
                input.type = 'radio';
                input.name = 'variant';
                input.value = index;
                input.checked = index === activeVariant;
                label.append(input, ...Array.from(name.childNodes, node => node.cloneNode(true)));


                input.addEventListener(
                    'change',
                    () => {

                        activeVariant =
                            index;


                        updateVariantContent();

                        renderPackageOptions();

                        renderGallery();


                        /*
                         * Setiap kali variant berubah,
                         * kembali ke image pertama
                         * (image general).
                         */

                        mainSlider.go(0);

                    }
                );


                variantsElement.appendChild(
                    label
                );

            }
        );

    }


    /*
     * ==========================================================
     * RENDER GALLERY
     * ==========================================================
     */

    function renderGallery() {

        const gallery =
            getVariantGallery();


        /*
         * ==============================================
         * SLIDE TEMPLATE
         * ==============================================
         */

        const slide = item => `

            <li
                class="splide__slide"
                data-package="${item.package}"
            >

                <img
                    src="${item.image}"
                    alt=""
                >

            </li>

        `;


        /*
         * ==============================================
         * MAIN SLIDES + THUMBNAILS
         * ==============================================
         *
         * Slide diurutkan sesuai urutan package
         * di HTML: general, lalu pcs, lalu box.
         *
         * Main dan thumbs berisi slide yang sama.
         * Jumlah slide HARUS sama di keduanya,
         * karena sync() Splide memetakan
         * index ke index.
         */

        const mainSlides =
            gallery.map(slide);


        const thumbSlides = mainSlides;


        /*
         * ==============================================
         * REPLACE SPLIDE SLIDES
         * ==============================================
         *
         * remove() wajib diberi selector.
         *
         * Tanpa selector, remove() TIDAK
         * menghapus slide apa pun — slide lama
         * akan bertumpuk dengan slide baru.
         */

        mainSlider.remove(
            '.splide__slide'
        );

        thumbsSlider.remove(
            '.splide__slide'
        );


        mainSlider.add(
            mainSlides
        );

        thumbsSlider.add(
            thumbSlides
        );


        /*
         * ==============================================
         * SYNC KEMASAN
         * ==============================================
         *
         * Setelah render ulang (mis. ganti variant),
         * event "moved" tidak selalu terpicu,
         * jadi sinkronkan manual dari slide pertama.
         */

        syncPackageSelect(0);

    }

    function renderPackageOptions() {
        const packages = getActiveVariant().querySelectorAll('.product__package[data-package]');
        packageListElement.replaceChildren();

        packages.forEach(packageElement => {
            const packageName = packageElement.dataset.package;
            if (!packageName || !packageElement.querySelector('.product__gallery')) return;

            const item = document.createElement('li');
            item.dataset.package = packageName;
            item.textContent = packageName === 'general' ? 'Pilih Kemasan' : packageName;
            item.addEventListener('click', () => {
                mainSlider.go(getPackageIndex(packageName));
                syncPackageSelect(mainSlider.index);
            });
            packageListElement.appendChild(item);
        });

        activePackage = packageListElement.firstElementChild?.dataset.package || null;
        updatePackageOptions();
    }


    /*
     * ==========================================================
     * PACKAGE INDEX
     * ==========================================================
     *
     * Index image PERTAMA dari sebuah package
     * di dalam slider.
     *
     * Dihitung dari jumlah image semua package
     * yang berada SEBELUM package tersebut,
     * sesuai urutan di HTML
     * (general → pcs → box).
     */

    function getPackageIndex(
        packageName
    ) {

        const variant =
            getActiveVariant();


        const packages =
            variant.querySelectorAll(
                '.product__package'
            );


        let index = 0;

        let found = false;


        packages.forEach(
            packageElement => {

                if (found) {
                    return;
                }


                if (
                    packageElement.dataset.package
                    === packageName
                ) {

                    found = true;

                    return;

                }


                index += packageElement
                    .querySelectorAll(
                        '.product__gallery'
                    ).length;

            }
        );


        return index;

    }


    /*
     * ==========================================================
     * PACKAGE CHANGE
     * ==========================================================
     *
     * "Pilih Kemasan" = general.
     */

    // Opsi dan click handler dibuat ulang untuk setiap variant di renderPackageOptions().


    /*
     * ==========================================================
     * SYNC PACKAGE OPTIONS
     * ==========================================================
     *
     * Opsi "Kemasan" selalu mengikuti
     * package dari slide yang sedang tampil.
     *
     * Image "general" -> kemasan kembali
     * ke "Pilih Kemasan".
     */

    function syncPackageSelect(
        index
    ) {

        const slide =
            document.querySelectorAll(
                '#product-main .splide__slide'
            )[index];


        const packageName =
            slide
                ? slide.dataset.package
                : null;


        if (packageName === activePackage) {

            return;

        }


        activePackage = packageName || null;


        updatePackageOptions();

    }


    /*
     * ==========================================================
     * UPDATE PACKAGE OPTIONS
     * ==========================================================
     *
     * Menandai <li> yang sesuai dengan activePackage,
     * lalu menampilkan namanya di title.
     */

    function updatePackageOptions() {

        packageListElement.querySelectorAll('li').forEach(
            item => {

                item.classList.toggle(
                    'active',
                    item.dataset.package
                    === activePackage
                );

            }
        );


        const activeItem =
            packageOptionsElement.querySelector(
                '.product__options-list li.active'
            );


        packageTitleElement.textContent =
            activeItem
                ? activeItem.textContent.trim()
                : '';

    }


    /*
     * Dipanggil setiap kali slide aktif
     * berpindah (klik thumb, arrow, swipe).
     */

    mainSlider.on(
        'moved',
        syncPackageSelect
    );


    /*
     * ==========================================================
     * INITIALIZE
     * ==========================================================
     */

    renderVariants();

    updateVariantContent();

    renderPackageOptions();

    renderGallery();
}
